import React, {useState, useEffect} from "react";
import "./voluum-send-postbacks.scss";

const VoluumSendPostbacks = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [urlsList, setUrlsList] = useState(null);
    const [checkedUrls, setCheckedUrls] = useState({});
    const [urlCheckResults, setUrlCheckResults] = useState({});
    const [urlCheckLoading, setUrlCheckLoading] = useState({});

    const handleFileChange = (event) => {
        const file = event.target.files?.[0];

        if (!file) {
            setSelectedFile(null);
            setError("");
            return;
        }

        const isValidExtension = /\.(csv|txt)$/i.test(file.name);

        if (!isValidExtension) {
            setSelectedFile(null);
            setError("Unsupported file type. Please upload a CSV or TXT file.");
            return;
        }

        setSelectedFile(file);
        setError("");
    };

    const handleSubmit = async () => {
        if (!selectedFile) {
            return;
        }

        setCheckedUrls({});
        setUrlCheckResults({});
        setSuccessMessage("");
        setLoading(true);
        setError("");

        try {
            const formData = new FormData();
            formData.append("url_file", selectedFile);

            const localToken = localStorage.getItem("auth_token");

            const response = await fetch(
                `${localStorage.getItem("apiUrl")}api/bulk-postbacks`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${localToken}`,
                    },
                    body: formData,
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            setUrlsList(data.items);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleCheckUrl = async (url, isChecked, index) => {
        setUrlCheckLoading((prev) => ({ ...prev, [index]: true }));
        setError("");

        const toNumberBool = (v) => (v ? 1 : 0);

        try {
            const localToken = localStorage.getItem("auth_token");

            const response = await fetch(
                `${localStorage.getItem("apiUrl")}api/bulk-postbacks?check=${encodeURIComponent(url)}&send=${toNumberBool(isChecked)}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${localToken}`,
                    }
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            const result = response.status === 200 || data.status === 200 ? "OK" : data.message || data.status || JSON.stringify(data);
            setUrlCheckResults((prev) => ({
                ...prev,
                [index]: result,
            }));
            setSuccessMessage(data.message || "Check completed");
        } catch (err) {
            setError(err.message || "An error occurred during check.");
        } finally {
            setUrlCheckLoading((prev) => ({ ...prev, [index]: false }));
        }
    }

    return (
        <div className="eml-offers-checker">
            {!urlsList ? (
                <div className="upload-card">
                <div className="upload-card__header">
                    <div>
                        <p className="upload-title">Upload file</p>
                        <p className="upload-subtitle">
                            Accepted formats: .csv, .txt
                        </p>
                    </div>

                    {selectedFile ? (
                        <span className="upload-status success">File ready</span>
                    ) : (
                        <span className="upload-status muted">No file</span>
                    )}
                </div>

                <div className="expected-columns">
                    <p className="expected-columns__title">Upload a file with one URL per line</p>
                </div>

                <label className="upload-dropzone">
                    <input
                        type="file"
                        accept=".csv,.txt"
                        onChange={handleFileChange}
                    />
                    <div className="upload-dropzone__content">
                        <p className="upload-dropzone__title">
                            {selectedFile ? "Change file" : "Choose a file"}
                        </p>
                        <p className="upload-dropzone__hint">
                            Drag & drop or click to browse
                        </p>
                        {selectedFile ? (
                            <p className="upload-dropzone__file">
                                {selectedFile.name}
                            </p>
                        ) : null}
                    </div>
                </label>

                {error ? <p className="upload-error">{error}</p> : null}
                {successMessage ? (
                    <p className="upload-success">{successMessage}</p>
                ) : null}

                <button
                    className="blue-btn upload-submit"
                    disabled={!selectedFile || loading}
                    onClick={handleSubmit}
                >
                    {loading ? "Processing..." : "Send File"}
                </button>
            </div>
            ) : (
                <div className="results-card">
                    <div className="results-card__header">
                        <button
                            className="blue-btn upload-submit"
                            onClick={() => {
                                setUrlsList(null);
                                setSelectedFile(null);
                                setSuccessMessage("");
                                setError("");
                            }}
                        >
                            Upload another file
                        </button>
                    </div>

                    {Array.isArray(urlsList) ? (
                        urlsList.length ? (
                            <div className="url-grid">
                                <div className="url-grid__header url-grid__row">
                                    <div className="url-grid__cell url-grid__cell--title">urls</div>
                                    <div className="url-grid__cell url-grid__cell--title">send postback</div>
                                    <div className="url-grid__cell url-grid__cell--title">check status</div>
                                </div>
                                {urlsList.map((item, index) => (
                                    <div className="url-grid__row" key={index}>
                                        <div className="url-grid__cell url-grid__cell--url">{item.url}</div>
                                        <div className="url-grid__cell url-grid__cell--checkbox">
                                            {!urlCheckResults[index] && !item.failed && (
                                                <input 
                                                    type="checkbox" 
                                                    checked={checkedUrls[index] || false}
                                                    onChange={(e) => setCheckedUrls({...checkedUrls, [index]: e.target.checked})}
                                                />
                                            )}
                                        </div>
                                        <div className="url-grid__cell url-grid__cell--button">
                                            {!item.failed ? (
                                                urlCheckResults[index] ? (
                                                    <span className="url-check-result">{urlCheckResults[index]}</span>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        disabled={loading || urlCheckLoading[index]}
                                                        onClick={() => handleCheckUrl(item.url, checkedUrls[index] || false, index)}
                                                    >
                                                        {urlCheckLoading[index] ? "Checking..." : "Check"}
                                                    </button>
                                                )
                                            ) : ( <span className="url-check-result">{item.message}</span> )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="url-grid__empty">No URLs returned from server.</div>
                        )
                    ) : (
                        <pre>{JSON.stringify(urlsList, null, 2)}</pre>
                    )}
                </div>
            )}
        </div>
    );
};

export default VoluumSendPostbacks;
